export const noSpecialChars: RegExp = /[-0-9#@!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/